import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewExpensePage } from '../../../features/finance/expense-pages'
import { expenseCategoriesQueryOptions, taxRatesQueryOptions } from '../../../features/finance/queries'
import { newExpenseSearchSchema } from '../../../features/finance/search'

export const Route = createFileRoute('/_app/expenses/new')({
  staticData: { crumb: 'expenseNew' },
  validateSearch: newExpenseSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'expenses.create'),
  loader: ({ context }) => {
    // The form opens with the default tax rate: have the rates (and categories) ready.
    void context.queryClient.prefetchQuery(expenseCategoriesQueryOptions)
    return context.queryClient.ensureQueryData(taxRatesQueryOptions).catch(() => undefined)
  },
  component: NewExpensePage,
})
